import { useMemo } from 'react';
import { APPROVAL_READ_SCOPES, APPROVAL_WRITE_SCOPES, APPROVAL_APPROVE_SCOPES } from 'ui-product-approvals-common/constants/approvalScopes';
import { useGetHasScope } from './useGetHasScope';
const SCOPES_BY_ACTION = {
  read: APPROVAL_READ_SCOPES,
  write: APPROVAL_WRITE_SCOPES,
  approve: APPROVAL_APPROVE_SCOPES
};
const getScopeName = (approvalType, action) => {
  if (approvalType === undefined) {
    return undefined;
  }
  return SCOPES_BY_ACTION[action][approvalType];
};
export const useHasApprovalScope = (approvalType, action) => {
  const hasScope = useGetHasScope();
  const scopeName = getScopeName(approvalType, action);
  return useMemo(() => scopeName ? hasScope(scopeName) : false, [hasScope, scopeName]);
};